var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_147_70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 14.6665C12 15.7274 12.4214 16.7448 13.1716 17.4949C13.9217 18.2451 14.9391 18.6665 16 18.6665C17.0609 18.6665 18.0783 18.2451 18.8284 17.4949C19.5786 16.7448 20 15.7274 20 14.6665C20 13.6056 19.5786 12.5882 18.8284 11.8381C18.0783 11.0879 17.0609 10.6665 16 10.6665C14.9391 10.6665 13.9217 11.0879 13.1716 11.8381C12.4214 12.5882 12 13.6056 12 14.6665Z",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5427 22.2094L17.8853 27.8668C17.3853 28.3663 16.7074 28.6469 16.0007 28.6469C15.2939 28.6469 14.616 28.3663 14.116 27.8668L8.45733 22.2094C6.96563 20.7177 5.94978 18.817 5.53825 16.7479C5.12672 14.6788 5.33799 12.5341 6.14534 10.5851C6.95269 8.63603 8.31986 6.97015 10.074 5.79811C11.8281 4.62606 13.8904 4.00049 16 4.00049C18.1096 4.00049 20.1719 4.62606 21.926 5.79811C23.6801 6.97015 25.0473 8.63603 25.8547 10.5851C26.662 12.5341 26.8733 14.6788 26.4617 16.7479C26.0502 18.817 25.0344 20.7177 23.5427 22.2094Z",
    stroke: "#FF7D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvg);
export default __webpack_public_path__ + "static/media/location_svg.a59680c5d1a586a0a2d5672c05b5c44b.svg";
export { ForwardRef as ReactComponent };